import Debug from 'debug';
const debug = Debug('model:actions:hunt');

const MAX_HUNT_AMMO = 5;
const MAX_HUNT_FOOD = 10;

const message = ({ success, cost, gain }) => `${
  success ? `caught game worth **${gain.food} food**.` : 'came back **empty handed**'
}
	used **${cost.ammo} ammo** in the hunt`;

const attempt = () => {
  const result = {
    success: true,
    cost: {
      ammo: Math.floor(Math.random() * MAX_HUNT_AMMO)
    },
    gain: {
      food: 0
    }
  };

  if (!result.success) return result;

  result.gain.food += Math.floor(Math.random() * MAX_HUNT_FOOD);
  result.success = result.success && result.gain.food > 0;

  return result;
};

const executeSideEffects = (context, result) => {
  const { party, calendar } = context;
  const { gain, cost } = result;
  const { history, resources } = party;

  // Track action
  history.add({ action: 'hunt', day: calendar.step, result });

  // Update resources
  resources.delta({ food: gain.food, ammo: -cost.ammo }, context);
  debug(resources.attribs);

  // Time passes
  calendar.next(context);
};

const hunt = {
  title: ({ calendar, party }) => `Hunt (${party.history.remainingToday(calendar.step)})`,
  enabled: ({ party }) => party.resources.attribs.ammo >= MAX_HUNT_AMMO,
  execute: context => {
    const result = attempt(context);
    debug(result);
    executeSideEffects(context, result);

    return { result: { message: message(result) } };
  },
  tooltips: [['ammo', `0 - ${MAX_HUNT_AMMO}`]]
};

export default hunt;
